import SectionHeading from './SectionHeading';
import { entranceTypes } from '@/mocks/homeData';

export default function EntranceTypes() {
  return (
    <section id="entrances" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            eyebrow="入口类型"
            title="六种常见入口形式，各有各的用途"
            desc="官网入口、最新地址、官方网址、发布页、防走失入口与永久入口并不是互相替代的关系，而是配合使用的一整套线索。"
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {entranceTypes.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-primary-300"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                    {item.tag}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>

                <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                  {item.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line mt-0.5 text-primary-600"></i>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}